import { bacteriaMetaConfig } from './calculate_ctvalue.js';

export { bacteriaMetaConfig };

export const bacteriaLayoutConfig = [
    {
        label: 'Bacillus genus',
        page: 12,
        yOffset: 240,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 230,
        yResult: 230,
        yResulttext: 234,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Candida albicans',
        page: 12,
        yOffset: 270,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 260,
        yResult: 260,
        yResulttext: 264,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Clostridium difficile',
        page: 12,
        yOffset: 300,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 290,
        yResult: 290,
        yResulttext: 294,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Escherichia coli',
        page: 12,
        yOffset: 330,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 320,
        yResult: 320,
        yResulttext: 324,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Staphylococcus aureus',
        page: 12,
        yOffset: 360,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 350,
        yResult: 350,
        yResulttext: 354,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Akkermansia muciniphila',
        page: 12,
        yOffset: 444,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 434,
        yResult: 434,
        yResulttext: 438,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Alistipes putredinis',
        page: 12,
        yOffset: 474,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 464,
        yResult: 464,
        yResulttext: 468,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bacteroides genus',
        page: 12,
        yOffset: 504,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 494,
        yResult: 494,
        yResulttext: 498,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bacteroides fragilis',
        page: 12,
        yOffset: 534,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 524,
        yResult: 524,
        yResulttext: 528,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 12,
        yOffset: 564,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 554,
        yResult: 554,
        yResulttext: 558,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Roseburia hominis',
        page: 12,
        yOffset: 594,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 584,
        yResult: 584,
        yResulttext: 588,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 12,
        yOffset: 680,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 670,
        yResult: 670,
        yResulttext: 674,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium breve',
        page: 12,
        yOffset: 710,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 700,
        yResult: 700,
        yResulttext: 704,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium lactis',
        page: 12,
        yOffset: 740,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 730,
        yResult: 730,
        yResulttext: 734,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Bifidobacterium longum',
        page: 12,
        yOffset: 770,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 760,
        yResult: 760,
        yResulttext: 764,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 12,
        yOffset: 800,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 790,
        yResult: 790,
        yResulttext: 794,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 12,
        yOffset: 830,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 820,
        yResult: 820,
        yResulttext: 824,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus helveticus',
        page: 12,
        yOffset: 860,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 850,
        yResult: 850,
        yResulttext: 854,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus paracasei',
        page: 12,
        yOffset: 890,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 880,
        yResult: 880,
        yResulttext: 884,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus plantarum',
        page: 12,
        yOffset: 920,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 910,
        yResult: 910,
        yResulttext: 914,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus reuteri',
        page: 12,
        yOffset: 950,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 940,
        yResult: 940,
        yResulttext: 944,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 12,
        yOffset: 980,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 970,
        yResult: 970,
        yResulttext: 974,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Streptococcus thermophilus',
        page: 12,
        yOffset: 1010,
        xLabel: 64,
        xBarStart: 290,
        xBarGap: 53,
        xResult: 670,
        yLabel: 1000,
        yResult: 1000,
        yResulttext: 1004,
        xResulttext: 565,  
        show_result: true
    },
    {
        label: 'Akkermansia muciniphila',
        page: 18,
        yOffset: 655,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 645,
        yResult: 903,
        yResulttext: 649,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 24,
        yOffset: 855,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 845,
        yResult: 814,
        yResulttext: 849,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 26,
        yOffset: 180,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 170,
        yResult: 814,
        yResulttext: 174,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 28,
        yOffset: 310,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 300,
        yResult: 814,
        yResulttext: 304,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 23,
        yOffset: 824,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 814,
        yResult: 814,
        yResulttext: 818,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Alistipes putredinis',
        page: 35,
        yOffset: 182,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 172,
        yResult: 814,
        yResulttext: 176,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Bacteroides genus',
        page: 20,
        yOffset: 735,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 726,
        yResult: 903,
        yResulttext: 729,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Bacteroides genus',
        page: 26,
        yOffset: 219,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 209,
        yResult: 814,
        yResulttext: 213,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Bacteroides fragilis',
        page: 20,
        yOffset: 774,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 765,
        yResult: 903,
        yResulttext: 768,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Bacteroides fragilis',
        page: 28,
        yOffset: 349,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 339,
        yResult: 814,
        yResulttext: 343,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 18,
        yOffset: 694,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 684,
        yResult: 903,
        yResulttext: 688,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 19,
        yOffset: 731,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 722,
        yResult: 903,
        yResulttext: 726,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 23,
        yOffset: 863,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 853,
        yResult: 814,
        yResulttext: 857,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 26,
        yOffset: 258,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 248,
        yResult: 814,
        yResulttext: 252,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 28,
        yOffset: 388,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 378,
        yResult: 814,
        yResulttext: 382,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 31,
        yOffset: 274,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 264,
        yResult: 814,
        yResulttext: 268,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 33,
        yOffset: 434,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 424,
        yResult: 814,
        yResulttext: 428,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 35,
        yOffset: 221,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 211,
        yResult: 814,
        yResulttext: 215,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 38,
        yOffset: 757,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 747,
        yResult: 814,
        yResulttext: 751,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Bifidobacterium breve',
        page: 38,
        yOffset: 850,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 840,
        yResult: 814,
        yResulttext: 844,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Bifidobacterium longum',
        page: 38,
        yOffset: 889,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 879,
        yResult: 853,
        yResulttext: 883,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Lactobacillus gasseri',
        page: 38,
        yOffset: 928,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 918,
        yResult: 853,
        yResulttext: 922,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 38,
        yOffset: 967,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 957,
        yResult: 853,
        yResulttext: 961,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Lactobacillus reuteri',
        page: 38,
        yOffset: 1006,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 996,
        yResult: 853,
        yResulttext: 1000,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 37,
        yOffset: 944,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 934,
        yResult: 814,
        yResulttext: 938,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 37,
        yOffset: 860,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 850,
        yResult: 814,
        yResulttext: 854,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Candida albicans',
        page: 37,
        yOffset: 777,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 767,
        yResult: 814,
        yResulttext: 771,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 37,
        yOffset: 1022,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 1012,
        yResult: 814,
        yResulttext: 1016,
        xResulttext: 600,  
        show_result: false
    },  
    {
        label: 'Lactobacillus helveticus',
        page: 37,
        yOffset: 983,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 973,
        yResult: 814,
        yResulttext: 977,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Roseburia hominis',
        page: 33,
        yOffset: 473,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 463,
        yResult: 814,
        yResulttext: 467,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Roseburia hominis',
        page: 35,
        yOffset: 260,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 250,
        yResult: 814,
        yResulttext: 254,
        xResulttext: 600,  
        show_result: false
    },

    // Bifidobacterium bifidum
    // Bifidobacterium bifidum
    // Bifidobacterium bifidum
    // Bifidobacterium bifidum
    // Bifidobacterium bifidum
    // Bifidobacterium bifidum
    // Bifidobacterium bifidum

    {
        label: 'Bifidobacterium bifidum',
        page: 18,
        yOffset: 791,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 781,
        yResult: 903,
        yResulttext: 785,
        xResulttext: 600,  
        show_result: false
    },   
    {
        label: 'Bifidobacterium bifidum',
        page: 20,
        yOffset: 871,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 862,
        yResult: 903,
        yResulttext: 866,
        xResulttext: 600,  
        show_result: false
    },   
    {
        label: 'Bifidobacterium bifidum',
        page: 19,
        yOffset: 826,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 817,
        yResult: 903,
        yResulttext: 821,
        xResulttext: 600,  
        show_result: false
    },      
    {
        label: 'Bifidobacterium bifidum',
        page: 24,
        yOffset: 950,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 940,
        yResult: 814,
        yResulttext: 944,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium bifidum',
        page: 26,
        yOffset: 356,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 346,
        yResult: 814,
        yResulttext: 350,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium breve',
        page: 17,
        yOffset: 662,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 652,
        yResult: 903,
        yResulttext: 656,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Bifidobacterium lactis',
        page: 17,
        yOffset: 701,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 691,
        yResult: 903,
        yResulttext: 695,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Bifidobacterium longum',
        page: 17,
        yOffset: 740,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 730,
        yResult: 903,
        yResulttext: 734,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 17,
        yOffset: 779,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 769,
        yResult: 903,
        yResulttext: 773,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus paracasei',
        page: 17,
        yOffset: 818,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 808,
        yResult: 903,
        yResulttext: 812,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Lactobacillus plantarum',
        page: 17,
        yOffset: 857,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 847,
        yResult: 903,
        yResulttext: 851,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium breve',
        page: 18,
        yOffset: 830,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 820,
        yResult: 903,
        yResulttext: 824,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium breve',
        page: 20,
        yOffset: 910,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 901,
        yResult: 903,
        yResulttext: 905,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium breve',
        page: 19,
        yOffset: 865,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 856,
        yResult: 903,
        yResulttext: 860,
        xResulttext: 600,  
        show_result: false
    },
    {
        label: 'Bifidobacterium breve',
        page: 26,
        yOffset: 395,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 385,
        yResult: 814,
        yResulttext: 389,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium breve',
        page: 35,
        yOffset: 360,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 350,
        yResult: 814,
        yResulttext: 354,
        xResulttext: 600,  
        show_result: false
    }, 
    // {
    //     label: 'Bifidobacterium breve',
    //     page: 26,
    //     yOffset: 910,
    //     xLabel: 95,
    //     xBarStart: 350,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 900,  
    //     yResult: 700,
    //     yResulttext: 904,
    //     xResulttext: 625,      
    //     show_result: false
    // }, 
    // {
    //     label: 'Bifidobacterium breve',
    //     page: 28,
    //     yOffset: 765,
    //     xLabel: 95,
    //     xBarStart: 350,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 755,  
    //     yResult: 700,
    //     yResulttext: 759,
    //     xResulttext: 625,     
    //     show_result: false
    // }, 

    // Bifidobacterium lactis
    // Bifidobacterium lactis
    // Bifidobacterium lactis
    // Bifidobacterium lactis
    {
        label: 'Bifidobacterium lactis',
        page: 23,
        yOffset: 957,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 948,
        yResult: 814,
        yResulttext: 952,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium lactis',
        page: 31,
        yOffset: 370,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 360,
        yResult: 814,
        yResulttext: 364,
        xResulttext: 600,  
        show_result: false
    }, 

    // Bifidobacterium longum
    // Bifidobacterium longum
    // Bifidobacterium longum
    // Bifidobacterium longum
    // Bifidobacterium longum
    // Bifidobacterium longum
    // Bifidobacterium longum
    // Bifidobacterium longum  
    {
        label: 'Bifidobacterium longum',
        page: 20,
        yOffset: 949,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 940,
        yResult: 903,
        yResulttext: 944,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium longum',
        page: 26,
        yOffset: 434,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 424,
        yResult: 814,
        yResulttext: 428,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium longum',
        page: 28,
        yOffset: 485,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 475,
        yResult: 814,
        yResulttext: 479,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium longum',
        page: 31,
        yOffset: 409,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 399,
        yResult: 814,
        yResulttext: 403,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bifidobacterium longum',
        page: 35,
        yOffset: 399,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 389,
        yResult: 814,
        yResulttext: 393,
        xResulttext: 600,  
        show_result: false
    }, 

    // Lactobacillus acidophilus
    // Lactobacillus acidophilus
    // Lactobacillus acidophilus
    // Lactobacillus acidophilus
    // Lactobacillus acidophilus
    // Lactobacillus acidophilus
    // Lactobacillus acidophilus
    {
        label: 'Lactobacillus acidophilus',
        page: 19,
        yOffset: 904,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 895,
        yResult: 903,
        yResulttext: 899,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 23,
        yOffset: 996,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 987,
        yResult: 814,
        yResulttext: 991,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 24,
        yOffset: 989,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 979,
        yResult: 814,
        yResulttext: 983,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 26,
        yOffset: 473,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 463,
        yResult: 814,
        yResulttext: 467,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus acidophilus',
        page: 31,
        yOffset: 448,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 438,
        yResult: 814,
        yResulttext: 442,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus gasseri',
        page: 26,
        yOffset: 512,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 502,
        yResult: 814,
        yResulttext: 506,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus gasseri',
        page: 28,
        yOffset: 524,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 514,
        yResult: 814,
        yResulttext: 518,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus helveticus',
        page: 35,
        yOffset: 438,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 428,
        yResult: 814,
        yResulttext: 432,
        xResulttext: 600,  
        show_result: false
    },  
    {
        label: 'Lactobacillus paracasei',
        page: 23,
        yOffset: 1035,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 1026,
        yResult: 814,
        yResulttext: 1030,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus paracasei',
        page: 24,
        yOffset: 1028,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 1018,
        yResult: 814,
        yResulttext: 1022,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus paracasei',
        page: 31,
        yOffset: 487,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 477,
        yResult: 814,
        yResulttext: 481,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus paracasei',
        page: 35,
        yOffset: 477,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 467,
        yResult: 814,
        yResulttext: 471,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 18,
        yOffset: 869,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 859,
        yResult: 903,
        yResulttext: 863,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 20,
        yOffset: 988,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 979,
        yResult: 903,
        yResulttext: 983,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 24,
        yOffset: 1064,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 1054,
        yResult: 814,
        yResulttext: 1058,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 26,
        yOffset: 551,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 541,
        yResult: 814,
        yResulttext: 545,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 28,
        yOffset: 563,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 553,
        yResult: 814,
        yResulttext: 557,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus plantarum',
        page: 31,
        yOffset: 526,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 516,
        yResult: 814,
        yResulttext: 520,
        xResulttext: 600,  
        show_result: false
    }, 

    // Lactobacillus reuteri
    // Lactobacillus reuteri
    // Lactobacillus reuteri
    // Lactobacillus reuteri
    {
        label: 'Lactobacillus reuteri',
        page: 28,
        yOffset: 602,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 592,
        yResult: 814,
        yResulttext: 596,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Lactobacillus reuteri',
        page: 33,
        yOffset: 572,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 562,
        yResult: 814,
        yResulttext: 566,
        xResulttext: 600,  
        show_result: false
    }, 

    // Lactobacillus rhamnosus
    // Lactobacillus rhamnosus
    // Lactobacillus rhamnosus
    // Lactobacillus rhamnosus
    {
        label: 'Lactobacillus rhamnosus',
        page: 19,
        yOffset: 943,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 934,
        yResult: 903,
        yResulttext: 938,
        xResulttext: 600,  
        show_result: false
    },     
    {
        label: 'Lactobacillus rhamnosus',
        page: 31,
        yOffset: 565,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 555,
        yResult: 814,
        yResulttext: 559,
        xResulttext: 600,  
        show_result: false
    },     
    {
        label: 'Lactobacillus rhamnosus',
        page: 33,
        yOffset: 611,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 601,
        yResult: 814,
        yResulttext: 605,
        xResulttext: 600,  
        show_result: false
    },     
    {
        label: 'Streptococcus thermophilus',
        page: 20,
        yOffset: 1027,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 1018,
        yResult: 903,
        yResulttext: 1022,
        xResulttext: 600,  
        show_result: false
    },  
    {
        label: 'Streptococcus thermophilus',
        page: 33,
        yOffset: 650,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 640,
        yResult: 814,
        yResulttext: 644,
        xResulttext: 600,  
        show_result: false
    },  
    {
        label: 'Streptococcus thermophilus',
        page: 35,
        yOffset: 516,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 506,
        yResult: 814,
        yResulttext: 510,
        xResulttext: 600,  
        show_result: false
    },  
    {
        label: 'Bacillus genus',
        page: 28,
        yOffset: 178,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 168,
        yResult: 814,
        yResulttext: 172,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Bacillus genus',
        page: 33,
        yOffset: 179,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 169,
        yResult: 814,
        yResulttext: 173,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Candida albicans',
        page: 18,
        yOffset: 566,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 556,
        yResult: 903,
        yResulttext: 560,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Candida albicans',
        page: 28,
        yOffset: 217,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 207,
        yResult: 814,
        yResulttext: 211,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Candida albicans',
        page: 33,
        yOffset: 218,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 208,
        yResult: 814,
        yResulttext: 212,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Clostridium difficile',
        page: 33,
        yOffset: 257,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 247,
        yResult: 814,
        yResulttext: 251,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Escherichia coli',
        page: 19,
        yOffset: 601,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 592,
        yResult: 903,
        yResulttext: 596,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Escherichia coli',
        page: 33,
        yOffset: 296,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 286,
        yResult: 814,
        yResulttext: 290,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Staphylococcus aureus',
        page: 19,
        yOffset: 640,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 631,
        yResult: 903,
        yResulttext: 635,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Staphylococcus aureus',
        page: 31,
        yOffset: 177,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 167,
        yResult: 814,
        yResulttext: 171,
        xResulttext: 600,  
        show_result: false
    }, 
    {
        label: 'Staphylococcus aureus',
        page: 33,
        yOffset: 335,
        xLabel: 60,
        xBarStart: 323,
        xBarGap: 53,
        xResult: 685,
        yLabel: 325,
        yResult: 814,
        yResulttext: 329,
        xResulttext: 600,  
        show_result: false
    }
];